import { render, staticRenderFns } from "./QrMenu.vue?vue&type=template&id=0f2cfa4c&scoped=true&"
import script from "./QrMenu.vue?vue&type=script&lang=js&"
export * from "./QrMenu.vue?vue&type=script&lang=js&"
import style0 from "./QrMenu.vue?vue&type=style&index=0&id=0f2cfa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cfa4c",
  null
  
)

export default component.exports